<template>
  <div class="buildinfo">
    <div class="buildmain">
      <div class="title">{{ nowbuild.title }}</div>
      <div class="issue">
        <div class="author">作者:{{ nowbuild.author }}</div>
        <div class="time">发布时间:{{ nowbuild.createTime }}</div>
      </div>
      <div class="line"></div>
      <div class="infocontent">
        <div ref="reportHTML" v-html="htmlText" class="webcon"></div>
      </div>
    </div>
    <div class="tools">
      <div
        class="prev toolsingle"
        @mouseenter="buildshover('left', 1)"
        @mouseleave="buildshover('left', 0)"
        :style="{
          'margin-top': lefthover == 1 ? '-10px' : '0',
        }"
        @click="changeinfo(prev)"
      >
        <div
          class="sign"
          style="margin-right: 1.25vw"
          :style="{
            background: lefthover == 1 ? 'rgba(22, 104, 188, 1)' : 'white',
          }"
        >
          <img
            src="../assets/image/bluearrowleft.png"
            alt=""
            style="width: 1.25vw; height: 1.25vw"
            v-if="lefthover == 0"
          /><img
            src="../assets/image/whitearrowleft.png"
            alt=""
            style="width: 1.25vw; height: 1.25vw"
            v-if="lefthover == 1"
          />
        </div>
        <p class="thetitle">上一篇：{{ prev.title }}</p>
      </div>
      <div
        class="next toolsingle"
        style="justify-content: flex-end"
        @mouseenter="buildshover('right', 1)"
        @mouseleave="buildshover('right', 0)"
        :style="{
          'margin-top': righthover == 1 ? '-10px' : '0',
        }"
        @click="changeinfo(next)"
      >
        <p class="thetitle" style="padding-left: 1.25vw">
          下一篇：{{ next.title }}
        </p>
        <div
          class="sign"
          style="margin-left: 1.25vw"
          :style="{
            background: righthover == 1 ? 'rgba(22, 104, 188, 1)' : 'white',
          }"
        >
          <img
            src="../assets/image/bluearrowright.png"
            alt=""
            style="width: 1.25vw; height: 1.25vw"
            v-if="righthover == 0"
          />
          <img
            src="../assets/image/whitearrowright.png"
            alt=""
            style="width: 1.25vw; height: 1.25vw"
            v-if="righthover == 1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sendbuild: {},
      nowbuild: {},
      prev: {},
      next: {},
      lefthover: 0,
      righthover: 0,
      htmlText: "",
      list: [],
    };
  },
  methods: {
    buildshover(fx, index) {
      if (fx == "left") {
        this.lefthover = index;
      } else if (fx == "right") {
        this.righthover = index;
      }
    },
    changeinfo(e) {
      if (!e.id) {
        console.log("没有更多了");
        return;
      } else {
        for (let i in this.list) {
          i = Number(i);
          if (e.id == this.list[i].id) {
            this.nownews = this.list[i];
            this.htmlText = this.nownews.content;
            document.getElementsByTagName("html")[0].scrollTop = 0;
            if (this.list[i - 1]) {
              this.prev = this.list[i - 1];
            } else {
              this.prev = { title: "没有了" };
            }
            if (this.list[i + 1]) {
              this.next = this.list[i + 1];
            } else {
              this.next = { title: "没有了" };
            }
          }
        }
      }
    },
  },
  async created() {
    this.sendbuild = this.$route.query;
    let res = await this.$http.newslist(this.sendnews);
    console.log(this.sendbuild);
    this.list = res.data;
    if (res.code == 200) {
      for (let i in res.data) {
        i = Number(i);
        if (this.sendbuild.id == res.data[i].id) {
          this.nowbuild = res.data[i];
          this.htmlText = this.nowbuild.content;
          if (res.data[i - 1]) {
            this.prev = res.data[i - 1];
          } else {
            this.prev = { title: "没有了" };
          }
          if (res.data[i + 1]) {
            this.next = res.data[i + 1];
          } else {
            this.next = { title: "没有了" };
          }
        }
      }
    }
  },
};
</script>

<style scoped lang="less">
.buildinfo {
  .tools {
    .toolsingle {
      .thetitle {
        flex: 1;
      }
      .sign {
        width: 3.75vw;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      width: 40.1vw;
      height: 100%;
      background: #fff;
      font-size: 0.94vw;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    margin-top: 1.56vw;
    width: 100%;
    height: 3.75vw;
    background: transparent;
    display: flex;
    justify-content: space-between;
  }
  .buildmain {
    .infocontent {
      width: 100%;
      padding: 1.04vw 5.21vw 0 5.21vw;
      font-size: 16px;
      font-weight: normal;
      line-height: 30px;
      color: rgba(18, 20, 58, 0.65);
    }
    .line {
      width: 100%;
      height: 1px;
      background: rgba(236, 239, 244, 1);
    }
    .issue {
      height: 1.15vw;
      color: rgba(18, 20, 58, 0.45);
      font-size: 0.94vw;
      display: flex;
      gap: 1.56vw;
      margin-bottom: 1.72vw;
    }
    .title {
      width: 100%;
      height: 1.77vw;
      color: rgba(18, 20, 58, 1);
      font-weight: 550;
      margin-bottom: 1.35vw;
      font-size: 1.46vw;
      text-align: center;
    }
    background: #fff;
    padding: 3.13vw 15.63vw 5.21vw 15.63vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  width: 100%;
  min-height: 5.21vw;
  
  background-position: 0 0;
  background-size: 100% 100%;
  padding: 2.6vw 8.33vw 11.46vw 8.33vw;
}
</style>
